import '../css/app.scss';
import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import { throttle } from 'lodash';

/** Pages */
import Home from './pages/home';
import Base from './pages/base';
import Detail from './pages/detail';
import LindauerPrinzip from './pages/lindauer-prinzip';
import Configurator from './pages/configurator';

/** Transitions */
import DefaultTransition from './transitions/default';


/** Global Components */
import Header from './globals/header';
import Form from './components/form';
import IntroAnimation from './components/introAnimation';
import { ScrollTrigger } from './globals/gsap';
import TopLink from './components/topLink';

if (history.scrollRestoration) {
  history.scrollRestoration = 'manual';
}


$(() => {
	// init global components
	barba.use(barbaPrefetch);

	const $forms = $('[data-form="el"]');
	$forms.each((i, el) => {
		new Form($(el));
	});

	const $introAnimation = $('[data-intro-animation="el"]');
	if($introAnimation.length) {
		new IntroAnimation($introAnimation);
	}

	const $topLink = $('[data-top-link="el"]');
	if($topLink.length) {
		new TopLink($topLink);
	}

	// init barba
	barba.init({
		timeout: 30000,
		views: [Home, Base, LindauerPrinzip, Configurator, Detail],
		prevent: ({ el }) => {
			return (
				el.href.includes('#') ||
				el.href === window.location.href ||
				el.dataset.header === 'backlink'
			);
		},
		transitions: [DefaultTransition],
	});
});
